module.exports = __webpack_public_path__ + "img/coin.9510323c.svg";